import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { cn } from "@/lib/utils";
import TemplatePreviewCard from "../TemplatePreviewCard";
import type { MappableLead, VariableMapping } from "../variableMapping";

type StepPreselectedConfirmProps = {
  broadcastName: string;
  onBroadcastNameChange: (name: string) => void;
  recipientCount: number;
  audienceLabel: string;
  templateName: string;
  enableAiAgent: boolean;
  variableMapping: VariableMapping;
  selectedTemplateBodyText: string | undefined;
  sampleLead: MappableLead | undefined;
  // Real send count after recipient classification; null while unknown
  effectiveRecipientCount?: number | null;
};

const StepPreselectedConfirm = ({
  broadcastName,
  onBroadcastNameChange,
  recipientCount,
  audienceLabel,
  templateName,
  enableAiAgent,
  variableMapping,
  selectedTemplateBodyText,
  sampleLead,
  effectiveRecipientCount,
}: StepPreselectedConfirmProps) => {
  return (
    <div className="flex flex-col gap-4">
      <div>
        <p className="mb-2 text-lg font-bold">Revisar y Confirmar</p>
        <p className="mb-4 text-sm text-gray-600">
          Revisa los detalles del envío antes de crearlo.
        </p>
      </div>

      <div>
        <Label className="mb-1 block text-sm font-medium text-gray-700">
          Nombre del envío
        </Label>
        <Input
          value={broadcastName}
          onChange={(e) => onBroadcastNameChange(e.target.value)}
          placeholder="Reactivación de leads inactivos"
        />
      </div>

      <div className="flex flex-col gap-3">
        <Card>
          <CardContent className="p-4">
            <div className="grid gap-3 md:grid-cols-2">
              <div>
                <p className="text-xs font-medium text-gray-500">Destinatarios</p>
                <p className="text-lg font-bold">
                  {effectiveRecipientCount ?? recipientCount} leads
                </p>
                {effectiveRecipientCount != null && effectiveRecipientCount < recipientCount && (
                  <p className="text-xs text-gray-500">de {recipientCount} seleccionados</p>
                )}
              </div>
              <div>
                <p className="text-xs font-medium text-gray-500">Etapa</p>
                <p>{audienceLabel}</p>
              </div>
              <div>
                <p className="text-xs font-medium text-gray-500">Plantilla</p>
                <p>{templateName}</p>
              </div>
              <div>
                <p className="text-xs font-medium text-gray-500">Agente AI</p>
                <Badge
                  variant="outline"
                  className={cn(
                    "text-xs",
                    enableAiAgent ? "bg-green-100 text-green-800" : "bg-gray-100 text-gray-800"
                  )}
                >
                  {enableAiAgent ? "Activado" : "Desactivado"}
                </Badge>
              </div>
            </div>
          </CardContent>
        </Card>

        <TemplatePreviewCard
          bodyText={selectedTemplateBodyText}
          variableMapping={variableMapping}
          sampleLead={sampleLead}
        />
      </div>
    </div>
  );
};

export default StepPreselectedConfirm;
